import { ChangeEvent, FC, useEffect, useState } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'store/configureStore';
import { clearAddressSuggestionList, setAddressPlaceId } from 'store/formTemplate/formTemplateSlice';
import { fetchAddress } from 'store/formTemplate/formTemplateThunks';
import { isQldRegion } from 'utils/petFormHelpers';
import InputField from './InputField';

interface AddressInputProps {
    value: string;
    placeholder?: string;
    label?: string;
    name: string;
    rules?: RegisterOptions;
}

const AddressInput: FC<AddressInputProps> = ({
    value,
    placeholder = 'Type to search an address',
    label = 'Address',
    name = 'address',
    rules = {}
}) => {
    

    const [selectedKeyword, setSelectedKeyword] = useState("");
    const [nswWarning, setNswWarning] = useState(false);

    const addressSuggestions = useAppSelector(state => state.formTemplate.addressSuggestions);
    const addressPlaceId = useAppSelector(state => state.formTemplate.addressPlaceId);
    const inProgress = useAppSelector(state => state.formTemplate.inProgress);
    const dispatch = useAppDispatch();


    const handleSelectAddress = async (address: string, placeId: string, isNsw: boolean) => {
        setValue(name, address, { shouldValidate: true });
        setSelectedKeyword(address);
        await dispatch(clearAddressSuggestionList());
        await dispatch(setAddressPlaceId(placeId));
        if(!isNsw){
            setNswWarning(true);
        }else{
            setNswWarning(false);
        }
    }

    const { setValue, register } = useFormContext();
    // const selectedKeyword = watch(name);



    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(setAddressPlaceId(""));
        const value = e.target.value;
        setSelectedKeyword(value);
        setValue(name, value, { shouldValidate: true });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            const selectedKeywordTrimmed = selectedKeyword?.trim();
            if (selectedKeywordTrimmed && selectedKeywordTrimmed.length > 0) {
                dispatch(fetchAddress({searchKey: selectedKeywordTrimmed || ""}));
            }
        }, 800);
        return () => clearTimeout(handler);
    }, [selectedKeyword, dispatch]); 

    return (
            <div className='position-relative'>
                <InputField
                    id="address-input"
                    label={label}
                    placeholder={placeholder}
                    type="text"
                    {...register(name, {
                      ...rules,
                      onChange: (e) => handleChange(e)
                    })}
                    value={selectedKeyword}
                />
                {/* Address Suggestions Dropdown */}
                {addressSuggestions && addressSuggestions.length > 0 && selectedKeyword?.length > 0  && !addressPlaceId ? (
                    <div className="dropdown-shadow position-absolute bg-white z-1 border border-grey-light radius-8px overflow-hidden w-100">
                    {addressSuggestions.map((addr, index) => (
                        <div
                        key={index}
                        className="px-15px py-8px d-flex align-items-center cursor-pointer hover-bg-off-white text-break"
                        onClick={() => handleSelectAddress(addr?.address || "", addr?.place_id || "", addr?.is_nsw || false)}
                        >
                        {addr?.address}
                        </div>
                    ))}
                    </div>
                ) 
                : (selectedKeyword && selectedKeyword.length > 0 && addressSuggestions.length === 0 && inProgress === false && addressPlaceId === "") ? 
                    <div className="dropdown-shadow position-absolute bg-white z-1 border border-grey-light radius-8px overflow-hidden w-100 py-10px pl-10px">No Address Found</div>
                : ""}
                {nswWarning && !isQldRegion() && (
                    <div className="text-warning fs-14px">
                        Warning: The selected address is outside of NSW. Some features may not work as expected.
                    </div>
                )}
            </div>
    );
};

export default AddressInput;